module.exports = __webpack_public_path__ + "static/suncor-895106443b5d22438c4f5a0fa963e32e.png";